import React, { Component } from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { localize } from 'react-localize-redux';
import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';
import TextField from '@material-ui/core/TextField';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

class ConfirmationDialog extends Component {
  state = {
    verified: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    let needsToConfirm = false;
    if (nextProps && nextProps.confirmationText) {
      needsToConfirm = true;
    }
    this.setState({ verified: !needsToConfirm });
  }

  render() {
    // TODO: This should be able to control its own state
    const {
      showDialog,
      hideDialog,
      disabled,
      userConfirmVerbiage,
      userConfirmAction,
      dialogTitle,
      dialogBodyVerbiage,
      fullScreen,
      hiddenCTA,
      confirmId, // TODO: rewrite this to just take a single function
    } = this.props;

    return (
      <Dialog
        disableBackdropClick
        fullScreen={fullScreen}
        open={showDialog}
        onRequestClose={hideDialog}
        onClose={this.props.toggleDialog}
        aria-labelledby="confirmation-dialog"
      >
        <DialogTitle>
          <h3 style={{ textAlign: 'center', margin: 0 }}>{dialogTitle}</h3>
        </DialogTitle>
        <DialogContent style={{ textAlign: 'center' }}>
          {dialogBodyVerbiage}

          {this._renderConfirmationText()}
        </DialogContent>
        <DialogActions style={{ display: 'block' }}>
          <FlatButton
            onClick={hideDialog}
            id="close-button"
            style={{ color: AccentColor(), textTransform: 'uppercase' }}
          >
            {this.props.translate('close')}
          </FlatButton>
          {!hiddenCTA && (
            <FlatButton
              variant="raised"
              onClick={() => this.state.verified && userConfirmAction(confirmId)}
              id="submit-button"
              style={{
                color: 'white',
                textTransform: 'uppercase',
                backgroundColor: !this.state.verified ? colors.LIGHT_GRAY : AccentColor(),
                paddingLeft: '5px',
                paddingRight: '5px',
              }}
              disabled={!this.state.verified || disabled}
            >
              {userConfirmVerbiage}
            </FlatButton>
          )}
        </DialogActions>
      </Dialog>
    );
  }

  _renderConfirmationText = () => {
    if (!this.props.confirmationText) return null;

    return (
      <div>
        <p>
          {getTranslatedString('landlordPortal.confirmationDialog.pleaseTypeToConfirm', {
            confirmationText: this.props.confirmationText,
          })}
        </p>
        <TextField
          style={{ width: '100%', fontSize: '13px' }}
          onChange={event => {
            this.updateConfirmationText(event.target.value);
          }}
        />
      </div>
    );
  };

  updateConfirmationText = value => {
    if (this.state.verified) return;

    this.setState({ verified: value === this.props.confirmationText });
  };
}

export default withMobileDialog()(localize()(ConfirmationDialog));
